module.exports = __webpack_public_path__ + "static/media/LRLE08.7b353822.jpg";